export const regexPatterns = {
  password: /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[a-zA-Z\d\w\W]{8,}$/,

  // in order to see acceptable phone formats look into tests
  phoneNumber:
    /^([+]?[\s0-9]+)?(\d{3}|[(]?[0-9]+[)])?(\/)?(([-.]?[\s]?)+?[0-9])+$/,
};
